import React, { useState, useEffect, useContext } from 'react'
import { AuthContextApi } from '../../Context/api'
import { toast } from 'react-toastify'
import {
    ChartBarIcon,
    UsersIcon,
    DocumentTextIcon,
    BoltIcon,
    UserGroupIcon,
    CalendarIcon,
} from '@heroicons/react/24/outline'
import { jsonConfig } from '../../Config'
import './styles.css'
import CardMetricas from '../../Components/Cards/Metricas'
import CardActions from '../../Components/Cards/Actions'

const Dashboard = () => {
    const { checkLogin, getDashBoardataSistema } = useContext(AuthContextApi)

    // Verificar permissão do usuário
    const userPermission = localStorage.getItem('permisssion')
    const isAdmin = true
    const isGerente = userPermission === jsonConfig.roles.gerente
    const isOperacional = userPermission === jsonConfig.roles.operacional

    // Estados locais

    // Estado para dados do dashboard
    const [dashboardStats, setDashboardStats] = useState([])


    const cardActions = [
        { id: 1, title: 'Investimentos', description: 'Gerencie e acompanhe os investimentos cadastrados', icon: CalendarIcon, href: '/investimentos' },
        { id: 2, title: 'Investidores', description: 'Visualize e gerencie a base de investidores', icon: UserGroupIcon, href: '/investidores' }
    ]


    // Função para carregar dados do dashboard (apenas para admin)
    const loadDashboardData = async () => {
        try {
            const response = await getDashBoardataSistema()
            if (response && response.status) {
                setDashboardStats(response.data)
            }
        } catch (error) {
            toast.error('Erro ao carregar dados do dashboard')
        }
    }

    // useEffect para carregar dados iniciais
    useEffect(() => {
        checkLogin()
        loadDashboardData()
    }, [])

    return (
        <div className="bg-gray-50 p-6">
            <div className="mb-8 flex flex-col sm:flex-row sm:items-center justify-between gap-4">
                <div className="flex items-center gap-4">
                    <div className="p-3 bg-gray-900 rounded-xl">
                        <ChartBarIcon className="w-6 h-6 text-brand-yellow" />
                    </div>
                    <div>
                        <h1 className="text-2xl font-bold text-gray-900">Dashboard</h1>
                        <p className="text-sm text-gray-400">Visão geral do sistema</p>
                    </div>
                </div>
                <div className="flex items-center gap-3">
                    <div className="text-right">
                        <p className="text-xs text-gray-400">Bem-vindo de volta,</p>
                        <p className="font-semibold text-sm text-gray-900">{localStorage.getItem('usuario') || 'Usuário'}</p>
                    </div>
                    <div className="w-9 h-9 bg-gray-900 rounded-full flex items-center justify-center">
                        <UsersIcon className="w-4 h-4 text-brand-yellow" />
                    </div>
                </div>
            </div>

            <CardActions actions={cardActions} />
            {isAdmin && <CardMetricas dataMetricas={dashboardStats} />}

        </div>
    )
}

export default Dashboard